import React from "react";
import CheckIcon from "/fallbacks/check.svg";
import parse from "html-react-parser";

const Checkbox = ({ register, name, error, value, handleChange, margin, trigger }) => {
  const checkboxText = window.checkboxText;

  return (
    <section className="policy">
      <div className="policy__checkbox" style={{ margin: margin ?? "" }}>
        <input
          className="policy__input"
          checked={value}
          type="checkbox"
          {...register(name)}
          id={name}
          name={name}
          onBlur={(event) => {
            trigger(event.target.name);
          }}
          onClick={handleChange}
        />
        <label className="policy__label" htmlFor="policy">
          {parse(checkboxText)}
        </label>
        {error && (
          <div style={{ gridRow: "2/3", gridColumn: "1/3" }} className="policyError">
            {error}
          </div>
        )}
        <label htmlFor={name} className="policy__check">
          <span style={{ backgroundImage: `url(${CheckIcon})` }}></span>
        </label>
      </div>
    </section>
  );
};

export default Checkbox;
